import React from 'react';
import { Home, TrendingUp, Target, Megaphone } from 'lucide-react';
import { servicesData } from '../data/mock';

const iconMap = {
  Home: Home,
  TrendingUp: TrendingUp,
  Target: Target,
  Megaphone: Megaphone
};

export const Services = () => {
  return (
    <section id="services" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-br from-[#0A1F3D] via-[#0D2847] to-[#0A1F3D] relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#C9A14A]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#C9A14A]/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6">
            Our <span className="text-[#C9A14A]">Services</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-300 max-w-2xl mx-auto leading-relaxed px-4">
            Comprehensive real estate solutions tailored to your needs
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#C9A14A] to-transparent mx-auto mt-6 sm:mt-8" />
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {servicesData.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={index}
                className="group relative bg-white/5 backdrop-blur-lg rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 hover:bg-white/10 transition-all duration-500 hover:transform hover:scale-105 hover:shadow-2xl"
              >
                {/* Icon Container */}
                <div className="mb-6 sm:mb-8 relative">
                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#C9A14A]/20 rounded-2xl flex items-center justify-center group-hover:bg-[#C9A14A] transition-all duration-300 group-hover:rotate-6">
                    <IconComponent className="w-8 h-8 sm:w-10 sm:h-10 text-[#C9A14A] group-hover:text-[#0A1F3D] transition-colors duration-300" />
                  </div>
                  {/* Glow Effect */}
                  <div className="absolute inset-0 bg-[#C9A14A]/30 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>

                {/* Content */}
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4 group-hover:text-[#C9A14A] transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-300 leading-relaxed text-sm sm:text-base">
                  {service.description}
                </p>

                {/* Border Glow */}
                <div className="absolute inset-0 rounded-2xl sm:rounded-3xl border-2 border-transparent group-hover:border-[#C9A14A]/50 transition-all duration-300 pointer-events-none" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
